@for(marker of markers(); track marker.id; let i = $index) {
    <map-marker 
        #markerRef="mapMarker"
        (mapClick)="getMarkerInfo(markerRef, marker)" 
        [position]="marker.location" 
        [options]="markerIcon(i)"
    />
}

<map-info-window>
    <div class="point-info-wrapper">
        <div class="point-info">
        <img
            draggable="false"
            [src]="selectedMarker?.image"
            (error)="onImageError($event)"
        />
        <span>
            {{ selectedMarker?.name?.[translate.currentLang] }}
        </span>
        </div>
    </div>
</map-info-window>